import React from 'react';
import ScrollReveal from './ScrollReveal';

const Subscribe = () => {
    return (
        <section className="bg-gray-100 py-16 px-4">
            <ScrollReveal animationClass="animate-fade-up" threshold={0.1} delay={200}>
                <div className="container mx-auto text-center">
                    <h2 className="text-3xl md:text-4xl font-semibold text-gray-800 font-cormorant-upright mb-4">
                        Subscribe to Our Newsletter
                    </h2>
                    <p className="text-gray-600 mb-8 max-w-2xl mx-auto">
                        Stay up to date with the latest news, tours, and special offers from Vrify Africa.
                    </p>
                    <form action="https://formsubmit.co/info@vrifyafrica.com" method="post" className="flex flex-col md:flex-row justify-center items-center">
                        <input
                            type="email"
                            name="email"
                            placeholder="Enter your email"
                            className="w-full md:w-auto px-4 py-2 rounded-l-md focus:outline-none text-gray-700 text-sm"
                        />
                        <button
                         type="submit"
                            className="bg-green-600 text-white text-sm font-semibold px-6 py-2 rounded-r-md hover:bg-green-700 transition-colors duration-300"
                        >
                            Subscribe
                        </button>
                    </form >
                </div>
            </ScrollReveal>
        </section>
    );
};

export default Subscribe;